/**
 * 翻译数据
 */
export interface TranslationData {
    /**
     * 片段索引
     */
    index: number;
    /**
     * 翻译结果
     */
    original: string;
}

/**
 * 更新翻译片段的能力
 */
export interface UpdateFragmentTranslation {
    /**
     * 更新翻译片段
     * @param fragment 翻译片段
     */
    updateTranslation(fragment: TranslationData): Promise<void>;
}

export const UpdateFragmentTranslation = Symbol('UpdateFragmentTranslation');
